// extracted by mini-css-extract-plugin
export default {"downloadItemContainer":"styles_downloadItemContainer__DYGUx"};